// Mock API for the new system dashboard
export async function getDashboardData() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        user: { name: 'Mateus Teixeira', role: 'Administrador', avatarUrl: null },
        stats: [
          { id: 'projects', title: 'Projetos ativos', value: 24, delta: '+4 desde ontem' },
          { id: 'awaiting', title: 'Aguardando resposta', value: 8, delta: '+2 desde ontem' },
          { id: 'contracts', title: 'Contratos para gerar', value: 6, delta: '+1 desde ontem' },
          { id: 'running', title: 'Projetos em execução', value: 12, delta: '+3 desde ontem' },
          { id: 'negotiations', title: 'Em negociações', value: 'R$ 328.000', delta: '+12% este mês' },
          { id: 'closed', title: 'Fechados este mês', value: 'R$ 124.500', delta: '+8% este mês' }
        ],
        activities: [
          { id: 1, title: 'Mateus Teixeira gerou um contrato', subtitle: 'Farmácia São Lucas · ORC-00235', time: 'Há 15 minutos' },
          { id: 2, title: 'Maria Oliveira alterou o orçamento', subtitle: 'Residência Alto Padrão · ORC-00234', time: 'Há 2 horas' },
          { id: 3, title: 'Negócio fechado', subtitle: 'Condomínio Bella Vista · ORC-00236', time: 'Há 3 horas', value: 'R$ 138.000' },
          { id: 4, title: 'Carlos Mendes gerou um contrato', subtitle: 'Empresa XPTO · ORC-00231', time: 'Há 4 horas' },
          { id: 5, title: 'Orçamento enviado para aprovação', subtitle: 'Loja Concept · ORC-00237', time: 'Há 5 horas' }
        ],
        funnel: [
          { status: 'Em elaboração', count: 18, amount: 'R$ 95.000', color: 'violet' },
          { status: 'Enviado', count: 8, amount: 'R$ 42.000', color: 'yellow' },
          { status: 'Negociação', count: 6, amount: 'R$ 83.000', color: 'orange' },
          { status: 'Fechado', count: 12, amount: 'R$ 124.500', color: 'green' },
          { status: 'Perdido', count: 4, amount: 'R$ 15.000', color: 'red' }
        ],
        reminders: [
          { id: 'r1', text: '3 orçamentos aguardando resposta', hint: 'Há mais de 3 dias' },
          { id: 'r2', text: '2 contratos para gerar', hint: 'Aguardando negócio fechado' },
          { id: 'r3', text: '1 contrato aguardando assinatura', hint: 'Enviado há mais de 5 dias' }
        ]
      });
    }, 300);
  });
}
